export default {"src":"/_next/static/media/CNC.62b2ffe3.svg","height":18,"width":18};